import React from 'react';
import { Button, Sym } from '../../../components/app2';
import EstadoSync, { esVivo } from './EstadoSync';
import {
  duracion, enCastellano, fechaHora, ORIGEN, periodoDe,
} from '../../../utils/syncFormat';

/**
 * Una sincronización en la lista: qué empresa, qué periodo, cómo va y qué trajo.
 *
 * Sirve igual para el monitor en vivo y para el histórico; lo único que cambia
 * son las acciones disponibles según el estado.
 */

const SyncRow = ({ solicitud, onCancelar, onReintentar, onVerDetalle, ocupado }) => {
  const vivo = esVivo(solicitud?.status);
  const empresa = solicitud?.company?.name || solicitud?.company?.businessName || 'Empresa';

  // La fila entera abre el detalle: es lo que uno intenta al ver una lista así.
  // Los botones de acción paran la propagación para no arrastrar consigo.
  const abrir = () => onVerDetalle?.(solicitud);

  return (
    <div
      className="a2-trow a2-sync-row"
      role={onVerDetalle ? 'button' : undefined}
      tabIndex={onVerDetalle ? 0 : undefined}
      aria-label={onVerDetalle ? `Ver el detalle de la sincronización de ${empresa}` : undefined}
      onClick={onVerDetalle ? abrir : undefined}
      onKeyDown={onVerDetalle ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); abrir(); } } : undefined}
      style={onVerDetalle ? { cursor: 'pointer' } : undefined}
    >
      <span className="a2-sync-main">
        <span className="a2-tcell-strong a2-truncate" style={{ display: 'block' }}>{empresa}</span>
        <span className="a2-tcell-muted a2-truncate" style={{ display: 'block' }}>
          <span className="a2-mono">{periodoDe(solicitud)}</span>
          {solicitud?.origin ? ` · ${ORIGEN[solicitud.origin] || solicitud.origin}` : ''}
        </span>
      </span>

      <span style={{ flex: '0 0 auto' }}>
        <EstadoSync status={solicitud?.status} />
      </span>

      <span className="a2-hide-sm a2-sync-dato" style={{ flexBasis: 130 }}>
        <span className="a2-tcell-muted" style={{ display: 'block' }}>Solicitada</span>
        <span className="a2-tcell" style={{ display: 'block' }}>{fechaHora(solicitud?.started_at)}</span>
      </span>

      <span className="a2-hide-sm a2-sync-dato" style={{ flexBasis: 90 }}>
        <span className="a2-tcell-muted" style={{ display: 'block' }}>Duración</span>
        <span className="a2-tcell a2-mono" style={{ display: 'block' }}>
          {duracion(solicitud?.started_at, solicitud?.completed_at)}
        </span>
      </span>

      <span className="a2-sync-dato" style={{ flexBasis: 132, minWidth: 96 }}>
        <span className="a2-tcell-muted" style={{ display: 'block' }}>Recibos</span>
        {solicitud?.status === 'terminada' ? (
          <span className="a2-tcell" style={{ display: 'block' }}>
            <span className="a2-mono" style={{ fontWeight: 700, color: 'var(--heading)' }}>
              {solicitud?.receipts_new ?? 0}
            </span>
            <span className="a2-tcell-muted"> nuevos</span>
            {(solicitud?.receipts_existing ?? 0) > 0 ? (
              <span className="a2-tcell-muted" style={{ display: 'block' }}>
                +{solicitud.receipts_existing} ya estaban
              </span>
            ) : null}
          </span>
        ) : (
          <span className="a2-tcell a2-mono" style={{ display: 'block', fontWeight: 700 }}>—</span>
        )}
      </span>

      <span className="a2-sync-acciones" onClick={(e) => e.stopPropagation()}>
        {onVerDetalle ? (
          <Button variant="ghost" size="sm" icon="visibility"
            onClick={abrir}
            aria-label={`Ver detalle de la sincronización de ${empresa}`}
          >
            Detalle
          </Button>
        ) : null}

        {solicitud?.status === 'encolada' && onCancelar ? (
          <Button variant="outline" size="sm" icon="cancel" loading={ocupado}
            onClick={() => onCancelar(solicitud)}
            aria-label={`Cancelar la sincronización de ${empresa}`}
          >
            Cancelar
          </Button>
        ) : null}

        {!vivo && solicitud?.status !== 'terminada' && onReintentar ? (
          <Button variant="outline" size="sm" icon="refresh" loading={ocupado}
            onClick={() => onReintentar(solicitud)}
            aria-label={`Reintentar la sincronización de ${empresa}`}
          >
            Reintentar
          </Button>
        ) : null}
      </span>

      {solicitud?.error_message ? (
        <span style={{ flexBasis: '100%', minWidth: 0 }}>
          <span
            className="a2-tcell-muted"
            style={{ display: 'flex', alignItems: 'flex-start', gap: 6, color: 'var(--danger)' }}
          >
            <Sym name="info" size={15} style={{ flexShrink: 0, marginTop: 1 }} />
            {enCastellano(solicitud.error_message)}
          </span>
        </span>
      ) : null}
    </div>
  );
};

export default SyncRow;
